import { useMemo, useState, useEffect } from "react";
import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button,
  HStack,
  Tag,
  TagLabel,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Grid,
  GridItem,
  Checkbox,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  TagCloseButton,
  IconButton,
  Skeleton,
  Image,
} from "@chakra-ui/react";
import { useColorModeValue } from "@chakra-ui/system";
import { BsColumnsGap } from "react-icons/bs";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import {
  SearchIcon,
  DeleteIcon,
  AddIcon,
  CloseIcon,
  ChevronDownIcon,
} from "@chakra-ui/icons";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import filterIcon from "common/assets/img/filterIcon.png";
import * as XLSX from "xlsx";
import Card from "common/components/card/Card";
import CountUpComponent from "common/components/countUpComponent";
import Pagination from "common/components/pagination/Pagination";
import Spinner from "common/components/spinner/Spinner";
import CustomSearchInput from "./search/search";
import AdvanceSearchUsingCustomFields from "./search/advanceSearch";
import DataNotFound from "./notFoundData";
import moment from "moment";
import ActionNavbar from "./actionBar/ActionNavbar";
import { constant } from "common/constant";
import CustomDatePicker from "./datePicker/CustomDatePicker";
import OutlinedIconBtn from "./customButtons/OutlinedIconBtn";
import { globalStyles } from "common/theme/styles";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { generateTimestampedFilename } from "common/utils/CalcFunctions";
import { recruitConstant } from "services/Recruit/constant";
import useGlobalTable from "services/Crm/utils/tableInstance";
import LocalSearch from "./search/localSeach";
import { crmConstant } from "services/Crm/constant";
import DotsIcon from "common/assets/img/dotHorizontal.png"

const CommonCheckTable = (props) => {
  const {
    isLoading,
    title,
    isSingleSelectionOnly,
    exportTitle,
    columnData,
    size,
    dataColumn,
    searchedDataOut,
    setSearchedDataOut,
    tableData,
    state,
    allData,
    ManageGrid,
    deleteMany,
    tableCustomFields,
    access,
    action,
    setAction,
    selectedColumns,
    setSelectedColumns,
    onOpen,
    setDelete,
    isHideNavbarAction = true,
    selectedValues,
    setSelectedValues,
    setIsImport,
    checkBox,
    AdvanceSearch,
    searchDisplay,
    setSearchDisplay,
    BackButton,
    searchboxOutside,
    setGetTagValuesOutside,
    setSearchboxOutside,
    isIdHide,
    onLinkClick = () => { },
    onRowClick,
    selectedRowBg = false,
    viewData,
    smallView = false,
    minColumnWidth = undefined,
    hideDatePicker = false,
    fullHeight = false,
    activeTab = false,
    kanbanViewHandle,
    listViewHandle,
    currentView,
    setCurrentPage = () => { },
    pageSize = 10,
    currentPage = 1,
    fetchData,
    metadata = {},
    setPageSize = () => { },
    handleSortChange = () => { },
    searchbox = "",
    setSearchbox = () => { },
    handleSearchChange = () => { },
    isPagination = true,
    isDynamic = false,
    isShowEmailBtn = false,
    handleNewEmailNotification,
  } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const columns = useMemo(() => dataColumn, [dataColumn]);
  const [tempSelectedColumns, setTempSelectedColumns] = useState(dataColumn); // State to track changes
  const colors = globalStyles.colors;
  const data = useMemo(() => {
    if (title === crmConstant.emailTitle) {
      return (AdvanceSearch ? searchDisplay : displaySearchData)
        ? AdvanceSearch
          ? searchedDataOut
          : searchedData
        : tableData;
    } else {
      if (!AdvanceSearch && displaySearchData && !isPagination) {
        return searchedData;
      } else {
        return tableData;
      }
    }
  }, [
    title,
    AdvanceSearch,
    searchDisplay,
    displaySearchData,
    searchedDataOut,
    searchedData,
    tableData,
  ]);

  const [manageColumns, setManageColumns] = useState(false);
  const [csvColumns, setCsvColumns] = useState([]);
  const [searchValue, setSearchValue] = useState({});
  const [getTagValues, setGetTagValues] = useState(
    props.getTagValuesOutSide ? props.getTagValuesOutSide : []
  );
  const [advaceSearch, setAdvaceSearch] = useState(false);
  const [column, setColumn] = useState("");
  const [gopageValue, setGopageValue] = useState();
  const [startDate, setStartDate] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const shouldShowDiv = location.pathname.includes("crm/leads");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const isCrmPath = ["/crm/leads", "/crm/tasks", "/crm/Deals"].some((path) =>
    currentPath.includes(path)
  );
  const [selectedView, setSelectedView] = useState(constant.selectView);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 500);
    return () => clearTimeout(timer);
  }, [data]);
  const page = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) return [];
    const safePageSize = pageSize || 10;
    const totalPages = Math.ceil(data.length / safePageSize);
    const safePageIndex = Math.min(currentPage || 1, totalPages);

    const start = (safePageIndex - 1) * safePageSize;
    const end = Math.min(start + safePageSize, data.length);

    return data.slice(start, end).map((item, index) => ({
      id: String(start + index),
      index: start + index,
      original: item,
      originalSubRows: [],
      subRows: [],
      depth: 0,
      values: item,
      cells: columns.map((col) => ({
        column: col,
        value: item[col.accessor] ?? "-",
      })),
    }));
  }, [data, currentPage, pageSize, columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
  } = useGlobalTable(columns, data);

  const handleSearch = (results) => {
    AdvanceSearch ? setSearchedDataOut(results) : setSearchedData(results);
  };

  const handleAdvanceSearch = (values) => {
    setSearchValue(values);
    const searchResult = allData?.filter((item) => {
      return tableCustomFields.every((field) => {
        const fieldValue = values[field.name];
        const itemValue = item[field.name];

        if (field.type === "select") {
          return !fieldValue || itemValue === fieldValue;
        } else if (field.type === "number") {
          return (
            [null, undefined, ""].includes(fieldValue) ||
            (itemValue !== undefined &&
              itemValue.toString().includes(fieldValue.toString()))
          );
        } else if (field.type === "date") {
          const fromDate = values[`from${field.name}`];
          const toDate = values[`to${field.name}`];

          if (!fromDate && !toDate) {
            return true; // No date range specified
          }

          const timeItemDate = new Date(itemValue);
          const timeMomentDate = moment(timeItemDate).format("YYYY-MM-DD");

          return (
            (!fromDate || timeMomentDate >= fromDate) &&
            (!toDate || timeMomentDate <= toDate)
          );
        } else {
          // Default case for text, email
          return (
            !fieldValue ||
            itemValue?.toLowerCase()?.includes(fieldValue?.toLowerCase())
          );
        }
      });
    });

    const getValue = tableCustomFields.reduce((result, field) => {
      if (field.type === "date") {
        const fromDate = values[`from${field.name}`];
        const toDate = values[`to${field.name}`];

        if (fromDate || toDate) {
          result.push({
            name: [`from${field.name}`, `to${field.name}`],
            value: `From: ${fromDate} To: ${toDate}`,
          });
        }
      } else if (values[field.name]) {
        result.push({
          name: [field.name],
          value: values[field.name],
        });
      }

      return result;
    }, []);

    setGetTagValues(getValue);
    setSearchedData(searchResult);
    setDisplaySearchData(true);
    setAdvaceSearch(false);
    if (setSearchbox) {
      setSearchbox("");
    }
  };

  const handleClear = () => {
    AdvanceSearch
      ? props?.setSearchDisplay(false)
      : setDisplaySearchData(false);
    if (searchboxOutside) {
      setSearchboxOutside("");
    } else {
      setSearchbox("");
    }
    setGetTagValues([]);
    if (props?.getTagValuesOutSide) {
      setGetTagValuesOutside([]);
    }
    setGopageValue(1);
  };

  const handleClick = () => {
    if (title === recruitConstant.createJobOpenings) {
      navigate("/recruit/jobProfileCreate");
    } else if (title === recruitConstant.createInterView) {
      navigate("/recruit/InterviewCreate");
    } else if (title === recruitConstant.createCandidate) {
      navigate("/recruit/candidatesCreate");
    } else if (title === recruitConstant.createDepartment) {
      navigate("/recruit/departmentCreate");
    } else if (title === recruitConstant.offerLetter) {
      navigate("/recruit/offerLetterCreate");
    } else if (title === recruitConstant.createApplications) {
      navigate("/recruit/applicationCreate");
    } else if (title === recruitConstant.createReferral) {
      navigate("/recruit/referralsCreate");
    } else if (title === recruitConstant.createCampaigns) {
      navigate("/recruit/campaignCreate");
    } else if (title === recruitConstant.bgVerification) {
      navigate("/recruit/bgVerificationCreate");
    } else if (title === recruitConstant.panel) {
      navigate("/recruit/panelCreate");
    } else if (title === recruitConstant.campaigns) {
      navigate("/recruit/campaignCreate");
    } else {
      onOpen();
    }
  };

  const findStatus = () => {
    const searchResult = allData?.filter(
      (item) =>
        !state ||
        (item?.status &&
          item?.status?.toLowerCase().includes(state?.toLowerCase()))
    );
    let getValue = [state || undefined].filter((value) => value);
    setGetTagValues(getValue);
    AdvanceSearch
      ? setSearchedDataOut && setSearchedDataOut(searchResult)
      : setSearchedData && setSearchedData(searchResult);
    AdvanceSearch
      ? setSearchDisplay && setSearchDisplay(true)
      : setDisplaySearchData && setDisplaySearchData(searchResult);
    setDisplaySearchData(true);
    setAdvaceSearch(false);
  };
  useEffect(() => {
    state && findStatus();
  }, [state, allData]);

  let isColumnSelected;
  const toggleColumnVisibility = (columnKey) => {
    setColumn(columnKey);
    isColumnSelected = tempSelectedColumns?.some(
      (column) => column?.accessor === columnKey
    );
    if (isColumnSelected) {
      const updatedColumns = tempSelectedColumns?.filter(
        (column) => column?.accessor !== columnKey
      );
      setTempSelectedColumns(updatedColumns);
    } else {
      const columnToAdd = columnData?.find(
        (column) => column?.accessor === columnKey
      );
      setTempSelectedColumns([...tempSelectedColumns, columnToAdd]);
    }
  };

  const handleCheckboxChange = (event, value) => {
    if (event.target.checked) {
      setSelectedValues &&
        setSelectedValues((prevSelectedValues) => [
          ...(isSingleSelectionOnly ? [] : prevSelectedValues),
          value,
        ]);
    } else {
      setSelectedValues &&
        setSelectedValues((prevSelectedValues) =>
          prevSelectedValues.filter((selectedValue) => selectedValue !== value)
        );
    }
  };

  const handleColumnClear = () => {
    isColumnSelected = selectedColumns?.some(
      (selectedColumn) => selectedColumn?.accessor === column?.accessor
    );
    setTempSelectedColumns(columnData);
    setManageColumns(!manageColumns ? !manageColumns : false);
  };

  const handleExportLeads = (extension) => {
    selectedValues && selectedValues?.length > 0
      ? downloadCsvOrExcel(extension, selectedValues)
      : downloadCsvOrExcel(extension);
  };

  const downloadCsvOrExcel = async (extension, selectedIds) => {
    try {
      if (selectedIds && selectedIds?.length > 0) {
        const selectedRecordsWithSpecificFileds = tableData
          ?.filter((rec) => selectedIds.includes(rec._id))
          ?.map((rec) => {
            const selectedFieldsData = {};
            csvColumns?.forEach((property) => {
              selectedFieldsData[property.accessor] = rec[property.accessor];
            });
            return selectedFieldsData;
          });
        convertJsonToCsvOrExcel(
          selectedRecordsWithSpecificFileds,
          csvColumns,
          exportTitle ? exportTitle : title || "data",
          extension
        );
      } else {
        const AllRecordsWithSpecificFileds = tableData?.map((rec) => {
          const selectedFieldsData = {};
          csvColumns?.forEach((property) => {
            selectedFieldsData[property?.accessor] = rec[property?.accessor];
          });
          return selectedFieldsData;
        });
        convertJsonToCsvOrExcel(
          AllRecordsWithSpecificFileds,
          csvColumns,
          exportTitle ? exportTitle : title || "data",
          extension
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const convertJsonToCsvOrExcel = (
    jsonArray,
    csvColumns,
    fileName,
    extension
  ) => {
    const csvHeader = csvColumns?.map((col) => col?.Header);

    const csvContent = [
      csvHeader,
      ...jsonArray?.map((row) => csvColumns?.map((col) => row[col?.accessor])),
    ];

    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const updatedFilename = generateTimestampedFilename(fileName, extension);

    XLSX.writeFile(wb, updatedFilename); // .csv, .xlsx
    setSelectedValues([]);
  };

  const handleRemove = (name) => {
    const filter = (props.getTagValuesOutSide || [])
      .concat(getTagValues || [])
      .filter((item) => {
        if (Array.isArray(name?.name)) {
          return name.name?.toString() !== item.name?.toString();
        }
      });
    let updatedSearchValue = { ...searchValue };
    for (let key in updatedSearchValue) {
      if (updatedSearchValue.hasOwnProperty(key)) {
        if (name.name.includes(key)) {
          delete updatedSearchValue[key];
        }
        if (updatedSearchValue[key] === "") {
          delete updatedSearchValue[key];
        }
      }
    }

    handleAdvanceSearch(updatedSearchValue);
    setGetTagValues(filter);
    if (filter?.length === 0) {
      handleClear();
    }
  };
  const handleNavigate = (cell) => {
    const original = cell?.row?.original;
    const header = cell?.column?.Header;

    if (header === "Rule Name" && original?._id) {
      navigate(`/crm/workflow-rules/create`, {
        state: {
          id: original._id,
          isEdit: true,
          workflowData: original
        }
      });
      return;
    }

    const targetId = original?.conversationId || original?._id;
    if (targetId && typeof onLinkClick === 'function') {
      const url = onLinkClick(targetId);
      if (url) {
        navigate(url, {
          state: viewData ? { module: viewData } : {},
        });
      }
    }
  };



  useEffect(() => {
    if (AdvanceSearch) {
      setSearchedDataOut && setSearchedDataOut(data);
    } else {
      setSearchedData && setSearchedData(data);
    }
  }, [AdvanceSearch, setSearchedDataOut, setSearchedData, data]);

  useEffect(() => {
    setTempSelectedColumns(dataColumn);
  }, [dataColumn]);

  useEffect(() => {
    if (selectedColumns) {
      const tempCsvColumns = selectedColumns
        ?.filter(
          (col) => col?.Header !== "#" && col?.Header !== constant.action
        )
        ?.map((field) => ({
          Header: field?.Header,
          accessor: field?.accessor,
        }));
      setCsvColumns([...tempCsvColumns]);
    }
  }, [selectedColumns]);

  const handleListView = () => {
    console.log("handlelistView Clicked");
  };

  const handleTableView = () => {
    console.log("handleTableView Clicked");
  };

  const tabActions = {
    list: handleListView,
    table: handleTableView,
  };

  const handleFilterSelect = (selectedOption) => {
    console.log("filterSelected", selectedOption);
  };

  const handleActionSelect = (option) => {
    console.log("Selected Action Option:", option);
  };

  const filterSelectOptions = constant.filterSelectList.map((item) => ({
    ...item,
    label: item.label.replace("title", title),
  }));
  const actionSelectOptions = constant.actionSelectList.map((item) => ({
    ...item,
    label: item.label.replace("title", title),
  }));
  const allSelectOptions = constant.allSelectOptions.map((item) => ({
    ...item,
    label: item.label.replace("title", title),
  }));

  useEffect(() => {
    const savedPaginationState = localStorage.getItem("paginationState");
    if (savedPaginationState) {
      const {
        pageName: savedPageName,
        currentPage: savedPage,
        pageSize: savedSize,
      } = JSON.parse(savedPaginationState);

      if (savedPageName === title) {
        setCurrentPage(savedPage || currentPage);
        setPageSize(savedSize || pageSize);
      } else {
        localStorage.removeItem("paginationState");
        setCurrentPage(1);
        setPageSize(10);
      }
    } else {
      const paginationState = {
        pageName: title,
        currentPage,
        pageSize,
      };
      localStorage.setItem("paginationState", JSON.stringify(paginationState));
    }
  }, [title]);
  const handlePaginationChange = (newPage) => {
    const totalPages = metadata?.totalPages || 1;
    if (newPage > totalPages) {
      console.warn(
        `Requested page ${newPage} exceeds total pages ${totalPages}.`
      );
      return;
    }

    if (newPage !== currentPage) {
      setCurrentPage(newPage);

      const paginationState = {
        pageName: title,
        currentPage: newPage,
        pageSize,
      };
      localStorage.setItem("paginationState", JSON.stringify(paginationState));

      if (isPagination) {
        if (isDynamic) {
          fetchData(viewData?._id, newPage, pageSize);
        } else {
          fetchData(newPage, pageSize);
        }
      }
    }
  };

  return (
    <>
      {/* {isHideNavbarAction && (
        <ActionNavbar
          title={title}
          onCreateClickHandler={handleClick}
          isCreateBtnVisible={access?.create || access === true}
          selectedValues={selectedValues}
          handleExportLeads={handleExportLeads}
          setManageColumns={setManageColumns}
          setIsImport={setIsImport}
          ManageGrid={ManageGrid}
          filterSelectOption={filterSelectOptions}
          onFilterSelect={handleFilterSelect}
          actionOptions={actionSelectOptions}
          handleActionSelect={handleActionSelect}
          activeTab={activeTab}
          listViewHandle={listViewHandle}
          kanbanViewHandle={kanbanViewHandle}
          currentView={currentView}
        />
      )} */}
      <Card
        direction="column"
        w="100%"
        overflowX={{ sm: "scroll", lg: "hidden" }}
        className={fullHeight ? "lead-table fullHeight" : "lead-table"}
      >
        <Grid
          templateColumns="repeat(12, 1fr)"
          gap={2}
          className="lead-table-header"
        >
          <GridItem
            colSpan={{ base: 12, md: 2, lg: 6 }}
            display={"flex"}
            alignItems={"center"}
          >
            <Flex
              w={"auto"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
            >
              <Box className="tableHeaderSearchWithBtn">
                {isPagination ? (
                  <CustomSearchInput
                    className="search-input"
                    setSearchbox={
                      setSearchboxOutside ? setSearchboxOutside : setSearchbox
                    }
                    setDisplaySearchData={
                      setSearchboxOutside
                        ? props.setSearchDisplay
                        : setDisplaySearchData
                    }
                    searchbox={
                      searchboxOutside ? searchboxOutside : searchbox || ""
                    }
                    allData={allData}
                    dataColumn={columns}
                    onSearch={handleSearchChange}
                    setGetTagValues={
                      props.setGetTagValuesOutside
                        ? props.setGetTagValuesOutside
                        : setGetTagValues
                    }
                    setGopageValue={setGopageValue}
                    handleSearchChange={handleSearchChange}
                  />
                ) : (
                  <LocalSearch
                    className="search-input"
                    setSearchbox={
                      setSearchboxOutside ? setSearchboxOutside : setSearchbox
                    }
                    setDisplaySearchData={
                      setSearchboxOutside
                        ? props.setSearchDisplay
                        : setDisplaySearchData
                    }
                    searchbox={
                      searchboxOutside ? searchboxOutside : searchbox || ""
                    }
                    allData={allData}
                    dataColumn={columns}
                    onSearch={handleSearch}
                    setGetTagValues={
                      props.setGetTagValuesOutside
                        ? props.setGetTagValuesOutside
                        : setGetTagValues
                    }
                    setGopageValue={setGopageValue}
                    source={title}
                    isPagination={isPagination}
                  />
                )}
              </Box>
            </Flex>
            {selectedValues?.length > 0 && access?.delete && !deleteMany && (
              <Box className="deleteIcon" onClick={() => setDelete(true)}>
                <div className="deleted-count">
                  <span>{selectedValues?.length ?? 0}</span>
                </div>
                <DeleteIcon
                  className=""
                  cursor={"pointer"}
                  color={colors.red[600]}
                />
              </Box>
            )}
          </GridItem>

          <GridItem
            colSpan={{ base: 12, md: 10, lg: 6 }}
            display={"flex"}
            gap={2}
            justifyContent={"end"}
            alignItems={"center"}
            textAlign={"right"}
          >
            {/* {isShowEmailBtn && (
              <Button variant={"brand"} type="button" onClick={handleNewEmailNotification} className="filledBtn">{constant.newEmailNotification}</Button>
            )} */}
            <Flex gap={"12px"} alignItems={"center"} className="tableActionBox">
              <Box className="lightBgBtn filterBtnMain">
                <OutlinedIconBtn
                  onClick={() => document.body.classList.toggle("openFilter")}
                  leftIcon={<Image h={"16px"} w={"16px"} src={filterIcon} mr={"4px"} />}
                  title={constant.filter}
                />
              </Box>

              {isCrmPath && (
                <Box display={"flex"} className="listDropdownCustom lightBgBtn">
                  <Menu isLazy>
                    <MenuButton className="">
                      <OutlinedIconBtn
                        borderColor={colors.borderColor}
                        color={colors.text["200"]}
                        rightIcon={
                          <ChevronDownIcon
                            fontSize={"xl"}
                            color={colors.text["200"]}
                          />
                        }
                        title={currentView}
                      />
                    </MenuButton>
                    <MenuList
                      className="exportSelectList"
                      minW={"fit-content"}
                      zIndex={2}
                    >
                      <MenuItem
                        onClick={() => {
                          setSelectedView(constant.listView);
                          listViewHandle();
                        }}
                        width={"165px"}
                      >
                        {constant.listView}
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setSelectedView(constant.tableView);
                          kanbanViewHandle();
                        }}
                        width={"165px"}
                      >
                        {constant.tableView}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Box>
              )}
              <Menu isLazy>
                <MenuButton className="lightBgBtn">
                  {/* <OutlinedIconBtn
                      borderColor={colors.cta["100"]}
                      color={colors.cta["100"]}
                      rightIcon={
                        <ChevronDownIcon
                          fontSize={"xl"}
                          color={colors.cta["100"]}
                        />
                      }
                      title={constant.action}
                    /> */}
                  <Button className="customOutlined-btn"><Image src={DotsIcon} height={"20px"} width={"20px"} alt="icon" /></Button>
                </MenuButton>


                <MenuList
                  className="exportSelectList"
                  minW={"fit-content"}
                  zIndex={2}
                >
                  <MenuItem
                    onClick={() => setManageColumns(true)}
                    width={"165px"}
                  >
                    {constant.manageColumns}
                  </MenuItem>
                  {typeof setIsImport === "function" && (
                    <MenuItem
                      width={"165px"}
                      onClick={() => setIsImport(true)}
                    >
                      {constant.import} {title}
                    </MenuItem>
                  )}
                  <MenuItem
                    width={"165px"}
                    onClick={() => handleExportLeads("csv")}
                  >
                    {selectedValues && selectedValues.length > 0
                      ? constant.exportSelectedDataAsCSV
                      : constant.exportAsCSV}
                  </MenuItem>
                  <MenuItem
                    width={"165px"}
                    onClick={() => handleExportLeads("xlsx")}
                  >
                    {selectedValues && selectedValues.length > 0
                      ? constant.exportSelectedDataAsExcel
                      : constant.exportAsExcel}
                  </MenuItem>
                </MenuList>
              </Menu>
              <Flex>
                {(access?.create || access === true) && (
                  <Button
                    size="sm"
                    variant="brand"
                    className="navCreateBtn"
                    onClick={handleClick}
                  >
                    {title === "New Password" ? (
                      <>
                        {constant.add}
                      </>
                    ) : (
                      <>{constant.create}</>
                    )}
                  </Button>
                )}
              </Flex>
            </Flex>
          </GridItem>
          <HStack spacing={4} mb={2}>
            {(props.getTagValuesOutSide || [])
              .concat(getTagValues || [])
              .map((item, i) => (
                <Tag
                  size={"md"}
                  p={2}
                  key={item.value}
                  borderRadius="full"
                  variant="solid"
                  colorScheme="gray"
                >
                  <TagLabel>{item.value}</TagLabel>
                  <TagCloseButton onClick={() => handleRemove(item)} />
                </Tag>
              ))}
          </HStack>
        </Grid>

        <div className="bodyPaginationContainer">
          <Box
            overflowY={"auto"}
            className={
              size ? `small-table-fix-container` : `table-fix-container`
            }
          >
            <Table
              {...getTableProps()}
              variant="simple"
              color="gray.500"
              mb="24px"
              className="lead-table-main"
            >
              <Thead zIndex={1}>
                {headerGroups?.map((headerGroup, index) => (
                  <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers
                      .filter((item) =>
                        isIdHide
                          ? item.Header !== "#" && item.Header !== "Delete Id"
                          : true
                      )
                      .map((column, index) => {
                        const handleSort = () => {
                          console.log(column, "column");
                          handleSortChange(column.id);
                        };

                        return (
                          <Th
                            {...column.getHeaderProps(
                              column.isSortable !== false &&
                              column.getSortByToggleProps()
                            )}
                            pe="10px"
                            key={index}
                            borderColor={borderColor}
                            onClick={handleSort}
                            className={`${column?.Header === "Action" ? "flexEndColumn" : ""
                              }`}
                          >
                            <Flex
                              align="center"
                              justifyContent={
                                column.center ? "center" : "start"
                              }
                              fontSize={{ sm: "14px", lg: "16px" }}
                              color="secondaryGray.900"
                            >
                              <span
                                className={`${column?.Header === "Action"
                                  ? "actionHeaderMargin"
                                  : "headerMargin"
                                  }`}
                                style={{ textTransform: "capitalize" }}
                              >
                                {column.render("Header")}
                              </span>
                              {column.isSortable !== false && (
                                <span>
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <FaSortDown />
                                    ) : (
                                      <FaSortUp />
                                    )
                                  ) : (
                                    <FaSort />
                                  )}
                                </span>
                              )}
                            </Flex>
                          </Th>
                        );
                      })}
                  </Tr>
                ))}
              </Thead>
              <Tbody {...getTableBodyProps()}>
                {showLoader || isLoading ? (
                  Array.from({ length: pageSize }).map((_, rowIndex) => (
                    <Tr key={`skeleton-row-${rowIndex}`}>
                      {columns.map((col, colIndex) => (
                        <Td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
                          <Skeleton height="20px" width="100%" />
                        </Td>
                      ))}
                    </Tr>
                  ))
                ) : data?.length === 0 ? (
                  <Tr>
                    <Td colSpan={columns.length} className="nodataTd">
                      <DataNotFound />
                    </Td>
                  </Tr>
                ) : (
                  page?.map((row, i) => {
                    prepareRow(row);
                    return (
                      <Tr
                        className={
                          selectedRowBg &&
                            selectedRow ===
                            (row.original?.conversationId || row.id)
                            ? "activeRow"
                            : ""
                        }
                        onClick={() => {
                          if (onRowClick) onRowClick(row);
                          setSelectedRow(
                            row.original?.conversationId || row.id
                          );
                        }}
                        {...row?.getRowProps()}
                      >
                        {row?.cells
                          .filter((item) =>
                            isIdHide
                              ? item.column.Header !== "#" &&
                              item.column.Header !== "Delete Id"
                              : true
                          )
                          ?.map((cell, index) => {
                            let data = "";
                            columnData?.forEach((item) => {
                              if (cell?.column.Header === item.Header) {
                                if (
                                  item.cell &&
                                  typeof item.cell === "function"
                                ) {
                                  data = (
                                    <Flex
                                      Flex
                                      align="center"
                                      justifyContent={
                                        item?.Header === "Action" && "end"
                                      }
                                    >
                                      <Text
                                        color={textColor}
                                        fontSize="sm"
                                        fontWeight="700"
                                      >
                                        {item.cell(cell) === " "
                                          ? "-"
                                          : item.cell(cell)}
                                      </Text>
                                    </Flex>
                                  );
                                } else {
                                  data = (
                                    <Flex align="center">
                                      {item.Header === "#" &&
                                        (checkBox ||
                                          checkBox === undefined) && (
                                          <Checkbox
                                            colorScheme="brandScheme"
                                            value={cell?.value}
                                            isChecked={selectedValues.includes(
                                              cell?.value
                                            )}
                                            disabled={
                                              cell.row.original.role ===
                                              "superAdmin"
                                            }
                                            onChange={(event) =>
                                              handleCheckboxChange(
                                                event,
                                                cell?.value
                                              )
                                            }
                                            me="10px"
                                          />
                                        )}
                                      <Box className="tableRow">
                                        <Text
                                          color={textColor}
                                          fontSize="sm"
                                          onClick={() => handleNavigate(cell)}
                                          fontWeight="700"
                                          className="link-like"
                                        >
                                          {item.Header === "#"
                                            ? // cell?.row?.index + 1
                                            (currentPage - 1) * pageSize +
                                            cell?.row?.index +
                                            1
                                            : cell?.value
                                              ? cell?.value
                                              : "-"}
                                        </Text>
                                      </Box>
                                    </Flex>
                                  );
                                }
                              }
                            });
                            return (
                              <Td
                                {...cell?.getCellProps()}
                                key={index}
                                fontSize={{ sm: "14px" }}
                                minW={
                                  cell?.column?.Header === "User Name"
                                    ? {
                                      sm: "150px",
                                      md: "200px",
                                      lg: minColumnWidth || "auto",
                                    }
                                    : "auto"
                                }
                                borderColor="transparent"
                              >
                                {data}
                              </Td>
                            );
                          })}
                      </Tr>
                    );
                  })
                )}
              </Tbody>
            </Table>
          </Box>

          {metadata?.totalRecords > 5 && (
            <Pagination
              smallView={smallView}
              gotoPage={(pageIndex) => handlePaginationChange(pageIndex + 1)}
              gopageValue={currentPage}
              setGopageValue={setCurrentPage}
              pageCount={metadata?.totalPages || 0}
              canPreviousPage={currentPage > 1}
              previousPage={() => handlePaginationChange(currentPage - 1)}
              canNextPage={currentPage < metadata?.totalPages}
              nextPage={() => handlePaginationChange(currentPage + 1)}
              pageOptions={Array.from(
                { length: metadata?.totalPages || 1 },
                (_, i) => i
              )}
              setPageSize={(size) => {
                setPageSize(size);
                setCurrentPage(1); // Reset to the first page when page size changes
                const paginationState = {
                  pageName: title,
                  currentPage: 1,
                  pageSize: size,
                };
                localStorage.setItem(
                  "paginationState",
                  JSON.stringify(paginationState)
                ); // Store the updated page size in localStorage
                if (isPagination)
                  if (isDynamic) {
                    fetchData(viewData?._id, currentPage, size);
                  } else {
                    fetchData(1, size);
                  }
              }}
              pageSize={pageSize}
              pageIndex={currentPage - 1}
              dataLength={metadata.totalRecords}
              isPagination={isPagination}
              allData={allData}
            />
          )}
        </div>

        {/* Manage Columns */}
        <Modal
          onClose={() => {
            setManageColumns(false);
          }}
          isOpen={manageColumns}
          isCentered
        >
          <ModalOverlay />
          <ModalContent maxW={"700px"}>
            <ModalHeader>{constant.manageColumns}</ModalHeader>
            <IconButton
              size="xs"
              className="closeIcon"
              onClick={() => {
                setManageColumns(false);
              }}
              icon={<CloseIcon />}
            />

            <ModalBody className="modalBody">
              <div>
                <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                  {columnData
                    ?.filter(
                      (column) =>
                        !(
                          (isIdHide && column?.Header === "#") ||
                          column?.Header === "Delete Id"
                        )
                    )
                    .map((column, index) => {
                      const isAction = column?.Header === "Action";
                      return (
                        <GridItem colSpan={1} key={index}>
                          <Text
                            display={"flex"}
                            py={2}
                            opacity={isAction ? 0.5 : 1}
                            className={`manageColumnText ${selectedColumns ? "selectedColumn" : ""}`}
                          >
                            <Checkbox
                              defaultChecked={selectedColumns?.some(
                                (selectedColumn) =>
                                  selectedColumn?.accessor === column?.accessor
                              )}
                              onChange={() =>
                                toggleColumnVisibility(column?.accessor)
                              }
                              pe={3}
                              isDisabled={isAction}
                            />
                            {column?.Header}
                          </Text>
                        </GridItem>
                      );
                    })}
                </Grid>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="outline"
                className="theme-btn2 cancelBtn"
                colorScheme={colors.red[600]}
                size="sm"
                onClick={() => handleColumnClear()}
              >
                Close
              </Button>
              <Button
                colorScheme="brand"
                className="theme-btn1"
                ml={4}
                onClick={() => {
                  setSelectedColumns([...tempSelectedColumns]);
                  setManageColumns(false);
                }}
                disabled={isLoading ? true : false}
                size="sm"
              >
                {isLoading ? <Spinner /> : "Save"}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </>
  );
};

export default CommonCheckTable;
